import { type FC } from "react";
import { useWatch } from "react-hook-form";
import { MultiLineText } from "@root/shared/components/MultiLineText";
import { type InputMessageProps } from "@clientFrontend/features/entry/components/NotAdopted/type";
import { SpView } from "./uiParts/SpView";
import { PcView } from "./uiParts/PcView";
import * as styles from "./styles.css";

export const InputMessage: FC<InputMessageProps> = ({
  mailChoices,
  mailDetail,
  userName,
  mailBodyParts,
  isSp,
}) => {
  const selectBoxOptions = mailChoices.map(({ value, text }) => {
    return { label: text, value };
  });

  const selectedMessageType: string = useWatch({
    name: "message",
  });

  const getMailBodyHeader = () => (
    <p>
      【リジョブ】
      {[
        "salon_tour",
        "salon_tour_turn_down",
        "salon_tour_not_come",
        "salon_tour_not_entry",
      ].includes(selectedMessageType)
        ? "今後の選考に関するご連絡"
        : "選考結果のご連絡"}
    </p>
  );

  const getMailBodyGreeting = () => (
    <p>
      いつも求人サイトリジョブをご利用いただき、誠にありがとうございます。
      <br />
      {[
        "salon_tour",
        "salon_tour_turn_down",
        "salon_tour_not_come",
        "salon_tour_not_entry",
      ].includes(selectedMessageType)
        ? "見学をご希望いただいた企業様"
        : "ご応募いただいた企業様"}
      より、
      <br />
      今後の選考について
      {selectedMessageType === "meet_condition"
        ? "不採用のご報告をいただきましたので通知いたします。"
        : "終了のご報告をいただきましたので、通知いたします。"}
    </p>
  );

  const getMailBodyReason = () => {
    const body = mailBodyParts[selectedMessageType];

    return <MultiLineText text={body} />;
  };

  const mailBody = () => {
    return (
      <div className={styles.formSendMailBox}>
        {getMailBodyHeader()}
        <p>{userName}様</p>
        {getMailBodyGreeting()}
        <br />
        <p>
          ・企業／店舗名
          <br />
          {mailDetail.clientName}
        </p>
        <p>
          ・求人タイトル
          <br />
          {mailDetail.workTitle}
        </p>
        {getMailBodyReason()}
        <br />
        <br />
        <p>
          上記の通知内容に関して、認識の相違等ございましたら、
          <br />
          誠に恐れ入りますが、カスタマーサポートセンターまでご連絡をお願い申し上げます。
        </p>
        <p>
          その他、ご不明な点などございましたらお気軽にお問い合わせくださいませ。
          <br />
          {userName}{" "}
          様の就職活動が実りあるものになりますよう、リジョブスタッフ一同心より祈念しております。
        </p>
        <p>
          ※本メールは企業様からいただいたご報告をもとに、リジョブのシステムより配信しております。
          <br />
          &emsp;企業様のご連絡と重ねて配信されることがございますがご了承ください。
        </p>
      </div>
    );
  };

  return (
    <>
      {isSp ? (
        <SpView
          selectBoxOptions={selectBoxOptions}
          mailBody={mailBody()}
          selectedMessageType={selectedMessageType}
        />
      ) : (
        <PcView
          selectBoxOptions={selectBoxOptions}
          mailBody={mailBody()}
          selectedMessageType={selectedMessageType}
        />
      )}
    </>
  );
};
